export const PendBtnIcon = ({ stroke = "#15112D", ...rest }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.83333 3.3335H5.5V16.6668H8.83333V3.3335Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5003 3.3335H12.167V16.6668H15.5003V3.3335Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
